import { useState, type JSX } from 'react';
import { Questionnaire, QuestionnaireResponse } from '@medplum/fhirtypes';
import { Document, QuestionnaireForm } from '@medplum/react';
import { Box, Text, Title } from '@mantine/core';

export function HipaaForm(): JSX.Element {
  const [isSubmitted, setIsSubmitted] = useState(false);

  async function handleSubmit(response: QuestionnaireResponse): Promise<void> {
    setIsSubmitted(true);
    window.scrollTo(0, 0);
  }

  return (
    <Document width={800}>
      {isSubmitted ? (
        <Box p="xl">
          <Title order={2}>Thank you for acknowledging our HIPAA Notice</Title>
          <Text mt="md">Your acknowledgment has been recorded.</Text>
        </Box>
      ) : (
        <QuestionnaireForm questionnaire={hipaaQuestionnaire} onSubmit={handleSubmit} />
      )}
    </Document>
  );
}

const hipaaQuestionnaire: Questionnaire = {
  resourceType: 'Questionnaire',
  status: 'active',
  title: 'HIPAA Notice of Privacy Practices Acknowledgment',
  item: [
    {
      linkId: 'hipaa-intro',
      text: 'Notice of Privacy Practices Acknowledgment',
      type: 'display'
    },
    {
      linkId: 'privacy-practices',
      text: 'I acknowledge that I have received a copy of the Notice of Privacy Practices, which explains how my health information will be used and disclosed.',
      type: 'boolean',
      required: true
    },
    {
      linkId: 'phi-understanding',
      text: 'I understand that my protected health information (PHI) may be used for treatment, payment, and healthcare operations.',
      type: 'boolean',
      required: true
    },
    {
      linkId: 'rights-understanding',
      text: 'I understand that I have the right to request restrictions on how my PHI is used and disclosed.',
      type: 'boolean',
      required: true
    },
    {
      linkId: 'electronic-records',
      text: 'I understand that my health information may be stored and transmitted electronically.',
      type: 'boolean',
      required: true
    },
    {
      linkId: 'authorization-understanding',
      text: 'I understand that, except as described in the Notice of Privacy Practices, my health information will not be disclosed without my authorization.',
      type: 'boolean',
      required: true
    },
    {
      linkId: 'hipaa-acknowledgment',
      text: 'By checking this box, I acknowledge that I have read and understand the HIPAA Notice of Privacy Practices.',
      type: 'boolean',
      required: true
    }
  ]
};